import { call, put, delay, takeLatest, select } from 'redux-saga/effects';
import normalize from 'jsonapi-normalizer';

import { portfolioIndices } from '../../../api';
import { resourceReducer } from '../../utils/resourceReducer';
import { transformActiveFilters, waitFor } from '../../../services';
import { activeFiltersSelector } from '../../ui/portfolio/selectors';

// Create actions and a reducer for the network resource
export const [actions, reducer, resourceSagas] =
  resourceReducer('portfolio-indices');

// Create the sagas for this entity
function* readPortfolioIndices() {
  yield takeLatest(actions.indexRequestBegin, function* () {
    yield call(waitFor, (state) => state.ui.portfolio.initialized);
    const activeFilters = yield select(activeFiltersSelector);
    const args = transformActiveFilters(activeFilters);

    try {
      const result = yield call(portfolioIndices.get, args);
      const normalized = normalize(result);
      const { meta } = result;
      yield put(actions.indexRequestSuccess({ ...normalized, meta }));
    } catch (error) {
      yield put(actions.indexRequestFailure({ error }));
      yield put({ type: 'ERRORS/HANDLE_API_ERROR', payload: error });
    }
  });
}

export const sagas = [readPortfolioIndices, ...resourceSagas];
